import { render, staticRenderFns } from "./PregnancyHistory.vue?vue&type=template&id=038cf2db&scoped=true"
import script from "./PregnancyHistory.vue?vue&type=script&lang=js"
export * from "./PregnancyHistory.vue?vue&type=script&lang=js"
import style0 from "./PregnancyHistory.vue?vue&type=style&index=0&id=038cf2db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038cf2db",
  null
  
)

export default component.exports